//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-empty.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-full.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-half-white.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-utilities/star-half-dark.svg';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'RatingStars',
  components: {
    MdmIcon
  },
  props: {
    rating: {
      type: Number,
      required: true
    },
    theme: {
      type: String,
      default: 'light'
    },
    size: {
      type: String,
      default: '12'
    }
  },
  computed: {
    enabledStarsCount() {
      return Math.floor(this.rating);
    },

    disabledStarsCount() {
      return 5 - Math.ceil(this.rating);
    },

    halfEnabledStar() {
      return !Number.isInteger(this.rating);
    }

  }
};